import { useEffect, useState } from 'preact/hooks';
import { useLocation } from 'wouter-preact';
import { Button } from '../ui/Button.jsx';
import { Sheet } from '../ui/Sheet.jsx';
import { useDb, useSession, useSync } from '../contexts.jsx';

export function Family({ familyKey }) {
  const { db } = useDb();
  const session = useSession();
  const sync = useSync();
  const [, navigate] = useLocation();
  const [state, setState] = useState(null);

  useEffect(() => {
    (async () => {
      const family = await db.get('families', familyKey);
      const members = await db.getAllFromIndex('people', 'by_family_key', familyKey);
      const existing = (await db.getAllFromIndex('handovers', 'by_family_key', familyKey)).find(
        (h) => !h.voided_at && h.local_status !== 'invalid',
      );
      setState({ family, members, existing });
    })();
  }, [db, familyKey, sync.lastSyncedAt]);

  if (!state) return null;
  const { family, members, existing } = state;
  if (!family) return <Sheet>Family not found in local roster.</Sheet>;

  const inBand = (m) => m.in_band;
  return (
    <>
      <Sheet>
        <div style={{ fontSize: 18, fontWeight: 600 }}>{family.name}</div>
        <div style={{ color: 'var(--muted)' }}>
          {family.address}
          {family.mandal ? ` · ${family.mandal}` : ''}
        </div>
      </Sheet>
      {existing && (
        <Sheet>
          <div style={{ color: 'var(--danger)', fontWeight: 600 }}>Already collected</div>
          <div>
            {existing.collected_name}
            {existing.station ? ` at ${existing.station}` : ''}
            {existing.created_at ? ` · ${new Date(existing.created_at).toLocaleString()}` : ''}
          </div>
        </Sheet>
      )}
      {!family.eligible && !existing && (
        <Sheet>
          <div style={{ color: 'var(--warn)' }}>
            Not gift-eligible (no member in age band {session.min_age}–{session.max_age})
          </div>
        </Sheet>
      )}
      <Sheet>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Household</div>
        {members.map((m) => (
          <div
            key={m.member_id}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '6px 0',
              borderBottom: '1px solid var(--border)',
              opacity: inBand(m) ? 1 : 0.6,
            }}
          >
            <span>
              {m.name}
              {m.member_id === family.collector_member_id ? ' ⭐' : ''}
            </span>
            <span style={{ color: 'var(--muted)' }}>
              {m.age ?? '—'} {m.gender || ''}
            </span>
          </div>
        ))}
      </Sheet>
      <Button
        variant="primary"
        block
        disabled={!!existing || !family.eligible}
        onClick={() => navigate(`/handover/${encodeURIComponent(familyKey)}`)}
      >
        {existing ? 'Handover complete' : 'Hand over gift'}
      </Button>
    </>
  );
}
